import { SendIcon } from "src/components/Icons";
import styled from "styled-components";

export const IconSend = styled(SendIcon)`
  path {
    stroke: none;
    fill: ${({ theme }) => theme.colors.constrat};
  }
`;

export const QuestionContent = styled.div`
  display: flex;
  background: transparent;
  flex-direction: column;
  gap: 22px;
  max-height: 158px;
  overflow-y: auto;
`;
